module.exports = __webpack_public_path__ + "img/auto-outline.3eb0c010.svg";